import { Model } from '../types';

export const getModelsOnly = (models?: Record<string, Model>) => {
  if (!models) return {};
  const filtered: Record<string, Model> = {};
  Object.keys(models).forEach((modelKey: string) => {
    if (models[modelKey].artifact_type === 'model') {
      filtered[modelKey] = models[modelKey];
    }
  });
  return filtered;
};
